import React from 'react';
import { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

const Wrapper = styled.div`
    padding: 0.5rem 0;
`;

const BillingInfoItemContactSummary = ({ item, currentContact }) => {
    const { cachedList } = useContext(ListContext);

    const invoicetypedefinitions =
        currentContact.ContactType === 'Model'
            ? cachedList.taxmethods.items.ModelInvoiceTypes
            : cachedList.taxmethods.items.CustomerInvoiceTypes;
    const invoiceType = invoicetypedefinitions.find((invtype) => invtype.Code === item.InvoiceType);

    const isContactNameDifferent =
        item.CompanyName &&
        item.CompanyName.trim().toLowerCase() !==
            (currentContact.Name + (currentContact.Surname ? ' ' + currentContact.Surname : '')).trim().toLowerCase();

    return (
        <Wrapper>
            <div className="info-row">
                <span>Billing Code:</span>
                <strong>{item.BillingCode}</strong>
            </div>
            {isContactNameDifferent && (
                <div className="info-row">
                    <span>Billing Name:</span>
                    <strong>{item.CompanyName}</strong>
                </div>
            )}
            {item.VatNumber && (
                <div className="info-row">
                    <span>VAT #:</span>
                    <strong>{item.VatNumber}</strong>
                </div>
            )}
            {item.FiscalID && (
                <div className="info-row">
                    <span>SSN / Tax ID / CF:</span>
                    <strong>{item.FiscalID}</strong>
                </div>
            )}
            <div className="info-row">
                <span>Billing Type:</span>
                <strong>{invoiceType.Name}</strong>
            </div>
        </Wrapper>
    );
};

export default BillingInfoItemContactSummary;
